/**
 * Parser hook types — DOM addEventListener model.
 * Hooks are fire-and-forget notifications (void return).
 *
 * HookContext is fully JSON-serializable — no internal refs, no classes.
 * Ready to ship over HTTP (webhook), message queue, n8n node input, etc.
 */

import { Schema } from 'effect';

export const ParserHookNameSchema = Schema.Literals([
  'upload',
  'before:parse',
  'after:step',
  'after:parse',
  'hydrated',
  'phase:change',
  'complete',
  'error',
]);

export type ParserHookName = typeof ParserHookNameSchema.Type;

export interface HookContext {
  hook: ParserHookName;
  documentId: string;
  phase: string;
  timestamp: number;
  /** Hook-specific payload — contents vary per hook name. */
  data: Record<string, unknown>;
}

export const HookContextSchema: Schema.Codec<HookContext> = Schema.Struct({
  hook: ParserHookNameSchema.pipe(Schema.mutableKey),
  documentId: Schema.String.pipe(Schema.mutableKey),
  phase: Schema.String.pipe(Schema.mutableKey),
  timestamp: Schema.Finite.pipe(Schema.mutableKey),
  data: Schema.Record(Schema.String, Schema.Unknown).pipe(Schema.mutableKey),
});
